module.exports = __webpack_public_path__ + "media/vraag_5_vraag.6dc1f902.mp3";